import '@lumoslabs/lux_fonts_js';
import './src/styles/global.css';

import React from 'react';
import { ApolloProvider } from 'react-apollo';
import client from './lumosApolloClient';

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = ({ element }) => <ApolloProvider client={client}>{element}</ApolloProvider>;
